var map = {
	"./amazon/canon_eos_m50_dump.json": 1107,
	"./amazon/nikkon_dump.json": 3652,
	"./amazon/nikkon_multiproduct_reviews_dump.json": 9900,
	"./bbb/aeg-bbb_dump.json": 2781,
	"./bbb/easycare-apco-bbb_dump.json": 6234,
	"./bbb/gwc-apco-bbb_dump.json": 6956,
	"./bbb/marinemax-mareq-bbb_dump.json": 1174,
	"./bbb/membercare-apco-bbb_dump.json": 1486,
	"./bbb/myeyedr-bbb_dump.json": 521,
	"./bbb/shopko-optical-bbb_dump.json": 9509,
	"./bbb/trynewleaf-bbb_dump.json": 3031,
	"./bestcompany/costco-optical-bestcompany_dump.json": 9524,
	"./consumeraffairs/carchex_dump.json": 7331,
	"./consumeraffairs/carshield_dump.json": 4473,
	"./consumeraffairs/coaf_dump.json": 2435,
	"./consumeraffairs/cohen-fashion-consumeraffairs_dump.json": 5597,
	"./consumeraffairs/endurance_dump.json": 5270,
	"./consumeraffairs/luxottica-consumeraffairs_dump.json": 931,
	"./consumeraffairs/nordictrack_dump.json": 6368,
	"./consumeraffairs/test1_dump.json": 5806,
	"./consumeraffairs/test2_dump.json": 605,
	"./consumeraffairs/visionworks-consumeraffairs_dump.json": 4985,
	"./consumeraffairs/walmart-vision-center-consumeraffairs_dump.json": 7826,
	"./getappza/homegauge-getappza_dump.json": 117,
	"./googlemaps/west1-shopkokobranches-googlemaps_dump.json": 8699,
	"./homedepot/groupa-blackstone_dump.json": 8180,
	"./homedepot/groupa-traeger_dump.json": 9612,
	"./homedepot/groupa-weber_dump.json": 6208,
	"./pissedconsumer/luxotica-pissedconsumer_dump.json": 4193,
	"./pissedconsumer/svs-pissedconsumer_dump.json": 9469,
	"./pissedconsumer/vision-source-pissedconsumer_dump.json": 6041,
	"./pissedconsumer/westmarine-mareq-pissedconsumer_dump.json": 1148,
	"./shopperapproved/boatzon-shopperapproved_dump.json": 1361,
	"./trustpilot/ahscom_dump.json": 6137,
	"./trustpilot/aventon-trustpilot_dump.json": 7935,
	"./trustpilot/cinchhomeservices_dump.json": 6885,
	"./trustpilot/eye-care-partners-trustpilot_dump.json": 4335,
	"./trustpilot/eye-mart-trustpilot_dump.json": 1700,
	"./trustpilot/gofahwcom_dump.json": 9020,
	"./trustpilot/ifit_dump.json": 1568,
	"./trustpilot/notion_dump.json": 7744,
	"./trustpilot/orhpcom_dump.json": 2007,
	"./trustpilot/peloton_dump.json": 332,
	"./trustpilot/radpower-europa-trustpilot_dump.json": 3807,
	"./trustpilot/rentalcover_dump.json": 1784
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4394;